import { useEffect } from 'react';
import PropTypes from 'prop-types';

import OfferPopup from './OfferPopup';
import { PredifinedPopUp } from 'components/predifinedPopUp';
import { PredifinedPopUpType2 } from 'components/predifinedPopUpType2';
import { PopUpNew } from 'components/popUpNew';

const RetargetingOffers = ({ offers = [] }) => {
    const showPopUpSetTimeout = () => {
        setTimeout(() => {
            const popupElms = document.querySelectorAll('.ab-set-hidden');
            popupElms.forEach((popupElm) => {
                const isExitPopup =
                    popupElm.classList.contains('ab-exit-popup');
                if (!isExitPopup) {
                    popupElm.classList.remove('ab-set-hidden');
                }
            });
        }, 1000);
    };

    useEffect(() => {
        const onMouseOut = (event) => {
            const shouldShowExitIntent =
                !event.toElement && !event.relatedTarget && event.clientY < 10;

            if (shouldShowExitIntent) {
                const popupElms = document.querySelectorAll('.ab-exit-popup');
                popupElms.forEach((popupElm) => {
                    popupElm.classList.remove('ab-set-hidden');
                });
            }
        };
        document.addEventListener('mouseout', onMouseOut);

        return () => {
            document.removeEventListener('mouseout', onMouseOut);
        };
    }, []);

    return (
        <>
            {offers.map((offer, index) => {
                if (offer.isPopUpNew) {
                    return <PopUpNew props={offer} key={index} />;
                } else if (offer.predefinedRetargeting === 7) {
                    return (
                        <PredifinedPopUpType2
                            props={offer}
                            key={index}
                            extraClass={`ab-set-hidden ${
                                offer.exitPopup ? 'ab-exit-popup' : ''
                            }`}
                        />
                    );
                } else {
                    if (offer.predefinedRetargeting === 6) {
                        return (
                            <PredifinedPopUp
                                props={offer}
                                key={index}
                                extraClass={`ab-set-hidden ${
                                    offer.exitPopup ? 'ab-exit-popup' : ''
                                }`}
                            />
                        );
                    }
                    return (
                        <OfferPopup
                            props={offer}
                            key={index}
                            extraClass={`ab-set-hidden ${
                                offer.exitPopup ? 'ab-exit-popup' : ''
                            }`}
                        />
                    );
                }
            })}
            {offers.length > 0 && showPopUpSetTimeout()}
        </>
    );
};

RetargetingOffers.propTypes = {
    offers: PropTypes.array,
};

export default RetargetingOffers;
